export function fetchState(stateKey, defaultState = {}) {
  if (sessionStorage.getItem(stateKey) === null) {
    return defaultState; // if empty initialize
  }

  return JSON.parse(sessionStorage.getItem(stateKey));
}

export function makeDataHashFromState(stateKey, extraStates = []) {
  const dataHash = {};

  const { pageState } = fetchState(stateKey);

  extraStates.forEach((extraStateKey) => {
    const extraState = fetchState(stateKey)[extraStateKey];

    if (extraState && extraState.length) {
      extraState.forEach((value) => {
        dataHash[value] = true;
      });
    }
  });

  if (pageState) {
    dataHash.page = pageState;
  }

  return dataHash;
}

export function makeSearchDataHash() {
  const data = makeDataHashFromState('search-state', ['filterState']);

  // If we're on 2nd page, and we're applying a filter, there may no longer be a 2nd page
  // So we need to delete the current page from the data before requesting a new search
  delete data.page;
  return data;
}

export function simpleDataHash(stateKey, paramKeys) {
  const dataHash = {};

  paramKeys.forEach((key) => {
    const paramKey = fetchState(stateKey)[key];

    if (paramKey && paramKey.length) {
      paramKey.forEach((value) => {
        dataHash[key] = value;
      });
    }
  });

  return dataHash;
}

export function setState(stateKey, newState) {
  if (newState) {
    sessionStorage.setItem(stateKey, JSON.stringify(newState));
  }
}

export function removeState(stateKey) {
  sessionStorage.removeItem(stateKey);
}

export function addToState(stateKey, paramKey, param) {
  const state = fetchState(stateKey);

  state[paramKey] = state[paramKey] || [];

  if (!state[paramKey].includes(param)) {
    state[paramKey].push(param);
    setState(stateKey, state);
  }
}

export function removeFromState(stateKey, paramKey, param) {
  const state = fetchState(stateKey);

  if (state[paramKey].includes(param)) {
    state[paramKey] = state[paramKey].filter(item => item !== param);
    setState(stateKey, state);
  }
}

export function removeParamKey(stateKey, paramKey) {
  const state = fetchState(stateKey);

  if (state[paramKey]) {
    delete state[paramKey];
    setState(stateKey, state);
  }
}

export function replaceParams(stateKey, paramKey, param) {
  removeParamKey(stateKey, paramKey);
  addToState(stateKey, paramKey, param);
}
